"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var empty = exports.empty = {
    closed: true,
    next: function next(value) {},
    error: function error(err) {
        throw err;
    },
    complete: function complete() {}
};
//# sourceMappingURL=Observer.js.map


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.3/Observer.js
// module id = 112
// module chunks = 0